import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { addCart } from "../redux/action";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import { Link } from "react-router-dom";

const Products = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [componentMounted, setComponentMounted] = useState(true);

  const dispatch = useDispatch();

  const addProduct = (product) => {
    dispatch(addCart(product));
  };

  useEffect(() => {
    const getProducts = async () => {
      setLoading(true);
      const response = await fetch("https://us-central1-ecommerce-nemotec.cloudfunctions.net/app/api/obtproductos");
      if (componentMounted) {
        const responseData = await response.json();
        setData(responseData.data);
        setLoading(false);
      }
    };
    getProducts();

    return () => {
      setComponentMounted(false);
    };
  }, [componentMounted]);

  // Resto del código...




  const Loading = () => {
    return (
      <>
        <div className="col-12 py-5 text-center">
          <Skeleton height={40} width={560} />
        </div>
        <div className="col-md-4 col-sm-6 col-xs-8 col-12 mb-4">
          <Skeleton height={592} />
        </div>
        <div className="col-md-4 col-sm-6 col-xs-8 col-12 mb-4">
          <Skeleton height={592} />
        </div>
        <div className="col-md-4 col-sm-6 col-xs-8 col-12 mb-4">
          <Skeleton height={592} />
        </div>
        <div className="col-md-4 col-sm-6 col-xs-8 col-12 mb-4">
          <Skeleton height={592} />
        </div>
        <div className="col-md-4 col-sm-6 col-xs-8 col-12 mb-4">
          <Skeleton height={592} />
        </div>
        <div className="col-md-4 col-sm-6 col-xs-8 col-12 mb-4">
          <Skeleton height={592} />
        </div>
      </>
    );
  };

  const handleImageError = (event) => {
    event.target.src =
      "https://firebasestorage.googleapis.com/v0/b/ecommerce-nemotec.appspot.com/o/not-found-image-15383864787lu.jpg?alt=media&token=63bcad96-7c75-4e25-a70d-943544dcf9bc&_gl=1*6ahpl5*_ga*NDUyODkzMTg0LjE2ODQ1Mjg1ODk.*_ga_CW55HF8NVT*MTY4NjA4Mjk4OS4xOS4xLjE2ODYwODMwMTAuMC4wLjA.";
  };

  const ShowProducts = () => {
    return (
      <>
        {data.map((product) => {
          return (
            <div id={product.id} key={product.id} className="col-md-4 col-sm-6 col-xs-8 col-12 mb-4">
              <div className="card text-center h-100" key={product.id}>
                <img
                  className="card-img-top p-3"
                  src={product.imagen}
                  alt="Card"
                  onError={handleImageError}
                  height={300}
                />
                <div className="card-body">
                  <h5 className="card-title">
                    {product.nombre.substring(0, 12)}...
                  </h5>
                  <p className="card-text">
                    {product.descripcion.substring(0, 90)}...
                  </p>
                </div>
                <ul className="list-group list-group-flush">
                  <li className="list-group-item lead">$ {product.precio}</li>
                </ul>
                <div className="card-body">
                  <Link to={"/product/" + product.id} className="btn btn-dark m-1">
                    Comprar ahora
                  </Link>
                  <button className="btn btn-dark m-1" onClick={() => addProduct(product)}>
                    Agregar al carrito
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </>
    );
  };

  return (
    <>
      <div className="container my-3 py-3">
        <div className="row">
          <div className="col-12">
            <h2 className="display-5 text-center">Últimos Productos</h2>
            <hr />
          </div>
        </div>
        <div className="row justify-content-center">
          {loading ? <Loading /> : <ShowProducts />}
        </div>
      </div>
    </>
  );
};

export default Products;
